import { useContext, useMemo } from 'react'

import { GlobalFiltersContext } from '../Providers/GlobalFiltersProvider'
import { InstitutionContext } from '../Providers/InstitutionProvider'
import { getIdOrNull, isNonEmptyArray } from '../utils'

const useInternshipEntityFilters = () => {
  const { internshipFilters } = useContext(GlobalFiltersContext)
  const institutionContext = useContext(InstitutionContext)

  const { hospitalDepartments = [], sectionToYears = [], sectors = [] } = internshipFilters

  const allSectors = useMemo(
    () => [...(institutionContext?.sectors ?? []), ...(institutionContext?.archivedSectors ?? [])],
    [institutionContext?.sectors, institutionContext?.archivedSectors]
  )

  const resolvedSectors = useMemo(() => {
    if (isNonEmptyArray(sectors)) {
      return sectors
    }

    if (isNonEmptyArray(hospitalDepartments)) {
      return allSectors
        .filter(sector => hospitalDepartments.includes(getIdOrNull(sector.hospitalDepartment)))
        .map(getIdOrNull)
    }

    return []
  }, [allSectors, hospitalDepartments, sectors])

  return useMemo(
    () => ({ hospitalDepartments, sectionToYears, sectors: resolvedSectors }),
    [hospitalDepartments, sectionToYears, resolvedSectors]
  )
}

export default useInternshipEntityFilters
